import type { FilterObject } from '@moment/trading-types/filter-expression'
import type {
  LiveInventoryItem,
  LiveInventoryReturnValues,
} from '@/types/api/live-inventory'

import {
  BondStatus,
  type IdentifierType,
} from '@moment/trading-types/reference-data'

import { useGetLiveInventoryPostQuery } from '@/legacy-api/data-slice'

interface UseGetInstrumentFromLiveInventoryProps {
  identifier: string | undefined
  identifierType: IdentifierType | undefined
  riskGroupId: string
  filters?: FilterObject
  returns: LiveInventoryReturnValues[]
  useCloseDataAfterHours?: boolean
}

export interface UseGetInstrumentFromLiveInventoryReturn {
  instrument: Partial<LiveInventoryItem> | undefined
  isLoading: boolean
  error: unknown
}

export function useGetInstrumentFromLiveInventory({
  identifier,
  identifierType,
  riskGroupId,
  filters = {},
  returns,
  useCloseDataAfterHours = true,
}: UseGetInstrumentFromLiveInventoryProps): UseGetInstrumentFromLiveInventoryReturn {
  const {
    data: referenceData,
    isLoading,
    error,
  } = useGetLiveInventoryPostQuery(
    {
      filters: {
        ...(identifierType && { [identifierType]: { equal_to: identifier } }),
        status: { equal_to: BondStatus.Outstanding }, // Fetching additional statuses can be passed in the filters object prop
        ...filters,
      },
      returns,
      risk_group_id: riskGroupId,
      use_close_data_after_hours: useCloseDataAfterHours,
    },
    {
      skip: !riskGroupId || !identifier,
    },
  )

  const instrument = referenceData?.data[0] as LiveInventoryItem | undefined

  return {
    instrument,
    isLoading,
    error,
  }
}
